import _get from 'lodash/get.js';
import uniq from 'lodash/uniq.js';
import axios from 'axios';
import castArray from 'lodash/castArray.js';
import trim from 'lodash/trim.js';
import jsonp from 'jsonp';
import toCamelCase from '../utils/camelCase';
import {
  API_ENDPOINT_THD_PRODUCT_DETAILS,
  API_ENDPOINT_GET_FREQUENTLY_BT,
  recordStormDoorApiSuccess,
  recordStormDoorApiFailure,
  recordApiResponse,
} from '../utils/newRelic';
import { catalog } from '../graphQL/queries/productQuery';
import { thdApiMap } from '../graphQL/mapping/thdApiMapping';

// if we query 1 itemId, thd returns `product` as an object.
// if we query 2+ itemIds, thd returns `product` as an array of objects.
// this will keep things consistent for us.
const castProductPropertyToArray = (responseData) => {
  const productData = castArray(responseData.products.product);
  return {
    products: {
      product: productData,
    },
  };
};

export const getThdProductDetails = (skuNumbers, storeId, config) => {
  const itemId = castArray(skuNumbers).join(',');
  const params = {
    itemId: config.useGraph ? uniq(skuNumbers) : itemId,
    storeId,
    environment: trim(config.thdApiEnvironmentMap) || undefined,
    key: config.thdApiKey,
    show: 'pricing,inventory,info,shipping,media',
    showLowestPrice: true,
  };

  const url = `${config.thdApiBaseUrl}/v3/catalog/products/sku`;
  const headers = {
    'Content-Type': 'application/json',
    'x-experience-name': config.graphHeaderValue,
  };

  const graphQLpromise = axios.post(
    `${config.graphThdApiBaseUrl}/federation-gateway/graphql`,
    {
      query: catalog,
      variables: {
        storeId,
        itemIds: skuNumbers,
      },
    },
    { headers }
  );
  if (config.useGraph) {
    return recordApiResponse(graphQLpromise, API_ENDPOINT_THD_PRODUCT_DETAILS)
      .then((res) => res.data)
      .then((result) => thdApiMap(result, params.storeId))
      .then(castProductPropertyToArray)
      .then(toCamelCase);
  }

  const promise = axios.get(url, { params });

  return recordApiResponse(promise, API_ENDPOINT_THD_PRODUCT_DETAILS, url, params)
    .then((response) => response.data)
    .then(castProductPropertyToArray)
    .then(toCamelCase);
};

export const getFrequentlyBoughtTogether = (itemId, config) => {
  const params = {
    itemId, // For local development use THD QA or Prod Ids, working example 100081634
    key: config.thdApiKey,
  };

  const url = `${config.thdApiBaseUrl}/fbt/v1?itemId=${params.itemId}&key=${params.key}`;

  return new Promise((resolve, reject) => {
    jsonp(url, null, (err, data) => {
      if (err) {
        recordStormDoorApiFailure(
          API_ENDPOINT_GET_FREQUENTLY_BT,
          _get(err.response, 'error.response.status')
            ? _get(err.response, 'error.response.status')
            : 500,
          url,
          params
        );
        reject(toCamelCase(err));
      } else {
        recordStormDoorApiSuccess(API_ENDPOINT_GET_FREQUENTLY_BT, '200');
        resolve(toCamelCase(data));
      }
    });
  });
};
